// Keep these ids aligned with server/src/features/catalog.ts.
// `ai` is the kill switch for every AI feature.
export const FEATURES = {
  ai: 'ai',
  github: 'connector_github',
  objectives: 'objectives',
  strava: 'connector_strava',
  substack: 'connector_substack',
  tasks: 'tasks',
  timesheet: 'timesheet',
  youtube: 'connector_youtube',
} as const;

export type FeatureId = typeof FEATURES[keyof typeof FEATURES];

export type FeatureFlags = Record<FeatureId, boolean>;

export const DEFAULT_FEATURES: FeatureFlags = {
  connector_github: true,
  connector_strava: true,
  connector_substack: true,
  connector_youtube: true,
  ai: true,
  objectives: true,
  tasks: true,
  timesheet: true,
};

export const FEATURE_SECTIONS = [
  {
    id: 'app',
    labelKey: null,
    features: [
      {
        descriptionKey: 'featureAiDescription',
        id: FEATURES.ai,
        labelKey: 'ai',
      },
      {
        descriptionKey: 'featureObjectivesDescription',
        id: FEATURES.objectives,
        labelKey: 'objectives',
      },
      {
        descriptionKey: 'featureTasksDescription',
        id: FEATURES.tasks,
        labelKey: 'tasks',
      },
      {
        descriptionKey: 'featureTimesheetDescription',
        id: FEATURES.timesheet,
        labelKey: 'timesheet',
      },
    ],
  },
  {
    id: 'connectors',
    labelKey: 'connectors',
    features: [
      {
        descriptionKey: 'featureGithubDescription',
        id: FEATURES.github,
        labelKey: 'connectorType_GITHUB',
      },
      {
        descriptionKey: 'featureStravaDescription',
        id: FEATURES.strava,
        labelKey: 'connectorType_STRAVA',
      },
      {
        descriptionKey: 'featureSubstackDescription',
        id: FEATURES.substack,
        labelKey: 'connectorType_SUBSTACK',
      },
      {
        descriptionKey: 'featureYoutubeDescription',
        id: FEATURES.youtube,
        labelKey: 'connectorType_YOUTUBE',
      },
    ],
  },
] as const;

export const isFeatureEnabled = (
  flags: Partial<FeatureFlags> | undefined,
  id: FeatureId,
) => {
  const value = flags?.[id];
  return typeof value === 'boolean' ? value : DEFAULT_FEATURES[id];
};
